"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _authorisation = _interopRequireDefault(require("../authorisation"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var noKVAuthorisation = new _authorisation.default(['admin', 'projectresponsible'], ['schub', 'vomhof', 'stallvisite', 'lockpfosten', 'brunch', 'toh'], true);

var CreateButton = /*#__PURE__*/function (_React$Component) {
  _inherits(CreateButton, _React$Component);

  function CreateButton(props) {
    _classCallCheck(this, CreateButton);

    return _possibleConstructorReturn(this, (CreateButton.__proto__ || Object.getPrototypeOf(CreateButton)).call(this, props));
  }

  _createClass(CreateButton, [{
    key: "render",
    value: function render() {
      var _this = this;

      return /*#__PURE__*/_react.default.createElement("div", {
        className: "project-detail-link"
      }, this.props.messages(), this.props.success === null && /*#__PURE__*/_react.default.createElement("button", {
        type: "button",
        onClick: function onClick() {
          return _this.props.createProject();
        },
        className: "btn btn--small center"
      }, this.props.t('Create project')));
    }
  }]);

  return CreateButton;
}(_react.default.Component);

var ErrorMessageButton = /*#__PURE__*/function (_React$Component2) {
  _inherits(ErrorMessageButton, _React$Component2);

  function ErrorMessageButton(props) {
    _classCallCheck(this, ErrorMessageButton);

    return _possibleConstructorReturn(this, (ErrorMessageButton.__proto__ || Object.getPrototypeOf(ErrorMessageButton)).call(this, props));
  }

  _createClass(ErrorMessageButton, [{
    key: "render",
    value: function render() {
      var t = this.props.t;
      return /*#__PURE__*/_react.default.createElement("span", {
        className: 'create-button-no-data center'
      }, t('no data'));
    }
  }]);

  return ErrorMessageButton;
}(_react.default.Component);

ErrorMessageButton.propTypes = {
  t: _propTypes.default.func.isRequired
};
CreateButton.propTypes = {
  t: _propTypes.default.func,
  messages: _propTypes.default.func,
  success: _propTypes.default.bool,
  createProject: _propTypes.default.func
};

var _default = noKVAuthorisation(CreateButton, ErrorMessageButton);

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./client/components/project-detail-link/create-button.js
// module id = 704
// module chunks = 0